var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: `Common HCP List` } },
            [
              _c(
                "el-form",
                {
                  staticClass: "filter-wrapper",
                  attrs: { "label-width": "60px" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Type" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "month-select",
                              attrs: {
                                placeholder: "Please select type",
                                loading: _vm.typeLoading,
                              },
                              on: { change: _vm.typeSelectChange },
                              model: {
                                value: _vm.typeId,
                                callback: function ($$v) {
                                  _vm.typeId = $$v
                                },
                                expression: "typeId",
                              },
                            },
                            _vm._l(_vm.typeOptions, function (item) {
                              return _c("el-option", {
                                key: item.typeid,
                                attrs: {
                                  label: item.typedescription,
                                  value: item.typeid,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                staticStyle: { width: "208px" },
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "ml10",
                  attrs: { type: "primary", loading: _vm.disableExportSEUser },
                  on: { click: _vm.exportSEList },
                },
                [_vm._v(" Export ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
              },
              on: {
                "sort-change": _vm.onSortChange,
                select: _vm.handleSelect,
                "select-all": _vm.handleSelectionAll,
              },
            },
            [
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "45", align: "center" },
                }),
              ],
              _vm.role !== 1
                ? _c("el-table-column", {
                    attrs: {
                      prop: "No",
                      width: "80",
                      label: "No.",
                      sortable: "custom",
                      align: "center",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: {
                  prop: "SEName",
                  label: "Name",
                  "min-width": "110",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "province",
                  label: "Province",
                  "min-width": "110",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "City",
                  label: "City",
                  "min-width": "80",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hospital",
                  label: "Hospital / Institution",
                  "min-width": "180",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Department",
                  label: "Department",
                  "min-width": "140",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Phone",
                  label: "Phone",
                  "min-width": "100",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Types",
                  label: "Type",
                  "min-width": "100",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "Tags", label: "Tag", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("hcp-tag-cell", { attrs: { value: row.Tags } }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "EngagementProfile",
                  label: "Engagement Profile",
                  width: "180",
                  sortable: "custom",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Match",
                  width: "160",
                  label: "iDoctor Match",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.tagTypeParserForiDoctor(
                                row.iDoctorStatus
                              ),
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.tagLabelParserForiDoctor(
                                    row.iDoctorStatus
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Certified",
                  width: "150",
                  label: "eMSL Certified",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.tagTypeParser(row.Active),
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.tagLabelParser(row.Active)) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "role",
                          rawName: "v-role",
                          value: [1, 2, 3, 13],
                          expression: "[1, 2, 3, 13]",
                        },
                      ],
                      attrs: {
                        type: "text",
                        icon: "iconfont icon-transfer",
                        size: "medium",
                        disabled: _vm.multipleSelection.length === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleTransferSE()
                        },
                      },
                    },
                    [_vm._v(" Mass Transfer ")]
                  ),
                ],
                1
              ),
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "pager-count": _vm.pagerCount,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("EditSEDialog", {
        attrs: { visible: _vm.editSEDialogVisible, data: _vm.rowData },
        on: {
          "update:visible": function ($event) {
            _vm.editSEDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("QRCodeDialog", {
        attrs: {
          visible: _vm.qrcodeDialogVisible,
          data: _vm.rowData,
          title: _vm.qrTitle,
        },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
      _c("TransferSEDialog", {
        attrs: {
          visible: _vm.transferSEDialogVisible,
          data: _vm.seIds,
          type: _vm.transferType,
          pageType: "CommonHCPList",
        },
        on: {
          "update:visible": function ($event) {
            _vm.transferSEDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.seIds = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("ImportSEDialog", {
        attrs: { visible: _vm.importSEDialogVieible },
        on: {
          "update:visible": function ($event) {
            _vm.importSEDialogVieible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("BatchAddDialog", {
        ref: "batchAddDialog",
        on: { success: _vm.operateUpload },
      }),
      _c("TableDialog", {
        ref: "tableDialog",
        on: {
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }